// 封装一个公共的 HTTP 请求类
import {ElMessage} from "element-plus";
import router from "@/router";

class R {

    // 封装 GET 请求方法
    public static isSuccess(data: any): boolean {
        if (!data) return false;
        return  data.code === "200";
    }

    public static precheck(data: any): any {
        if(data.code == 'A0401'){
            router.push("/login");
            return ;
        }
        if (!R.isSuccess(data)) {
            ElMessage({
                showClose: true,
                message: data.t,
                type: 'warning',
            })
        }
        return data;
    }
}

export default R;
